export default {
	namespaced: true,

	state: {
		showInputVoucherCodeDialog: false,
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
